var map = {
	"./assets/clickable/twitch.svg": "50bbd9847b5ea1596c5a",
	"./assets/disabled/twitch.svg": "3d0f76056090ab5ef243",
	"./assets/original/twitch.svg": "28c978ecae3bc59d2626"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "517e4683584b45dd013f";